import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { getEmailValidationError } from '../HoaDirectory/HoaDirectoryHelper';
import FormattedPhoneField from './FormattedPhoneField';

const ContactEditModal = ({ contact, show, onHide, onSave }) => {
  const [formData, setFormData] = useState({
    name: contact?.name || '',
    title: contact?.title || '',
    directPhone: contact?.directPhone || '',
    directEmail: contact?.directEmail || '',
  });
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    if (show && contact) {
      setFormData({
        name: contact.name || '',
        title: contact.title || '',
        directPhone: contact.directPhone || '',
        directEmail: contact.directEmail || '',
      });
      setEmailError('');
    }
  }, [contact, show]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (field === 'directEmail' && emailError) setEmailError('');
  };

  const handleSave = () => {
    const validationError = getEmailValidationError(formData.directEmail);
    if (validationError) {
      setEmailError(validationError);
      return;
    }

    onSave({
      ...contact,
      ...formData,
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Contact</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label className="small mb-1">Full name</Form.Label>
          <Form.Control
            type="text"
            size="sm"
            value={formData.name}
            onChange={e => handleChange('name', e.target.value)}
            placeholder="Enter contact name"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="small mb-1">Title / Role</Form.Label>
          <Form.Control
            type="text"
            size="sm"
            value={formData.title}
            onChange={e => handleChange('title', e.target.value)}
            placeholder="Enter title or role"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="small mb-1">Direct phone</Form.Label>
          <FormattedPhoneField
            value={formData.directPhone}
            onChange={e => handleChange('directPhone', e.target.value)}
            placeholder="Enter phone number"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="small mb-1">Direct email</Form.Label>
          <Form.Control
            type="email"
            size="sm"
            value={formData.directEmail}
            isInvalid={Boolean(emailError)}
            onChange={e => handleChange('directEmail', e.target.value)}
            placeholder="Enter email address"
          />
          {emailError && <p className="xsmallFont text-rush mb-0 mt-1">{emailError}</p>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactEditModal;
